import { filterOperatorGroups } from '../../components/filters/utils/definitions';
/** Checks if the given operator is nullish */
export function isNullishFilterOperator(operator) {
    return filterOperatorGroups.nullish.includes(operator);
}
